var render = function render(){var _vm=this,_c=_vm._self._c;return _c('rkm-modal',{ref:"RkmModal",attrs:{"buttons":['cancel', 'save'],"hide-header":"","persistent":""},on:{"save":_vm.handleSave}},[_c('Form',{ref:"Form",attrs:{"id":_vm.model.id},on:{"saved":_vm.saved}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }